<template>
    <div class="d-flex align-items-center gap-5">
        <div class="w-50">
            <nuxt-img src="/images/pages/organisme-formation/preparer-formation.jpeg"></nuxt-img>
        </div>
        <div class="w-50">
            <h2 class="mb-60">
                <span class="span-background-blue">Preparez votre formation</span>
            </h2>
            <p class="pb-3">
                Découvrez comment préparer votre prochaine session de formation.
            </p>
            <div>
                <a class="btn-rouge-outline" href="/preparez-votre-formation"><i class="fa-solid fa-newspaper"></i>
                    Les étapes en amont</a>
            </div>
        </div>
    </div>
</template>
<script setup>

</script>
<style scoped>
h2 {
    font-family: Nunito;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    /* 61.325px */
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

p {
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}

a {
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 135%;
    /* 27px */
    letter-spacing: 0.8px;
}

.btn-rouge-outline {
    border: 2px solid #318EC7;
}

.btn-rouge-outline:hover {
    background: #318EC7;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
    .d-flex {
        flex-direction: column;
        width: 100%;
        padding: 10px 10px;
    }

    h2 {
        font-size: 20px !important;
    }

    .w-50 {
        width: 90% !important;
    }
}

/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {}
</style>